// extracted by mini-css-extract-plugin
export var blog = "blog-module--blog--jheFh";
export var blogs = "blog-module--blogs--buGGB";
export var intro = "blog-module--intro--Nktyj";
export var pageContent = "blog-module--page-content--Nudl1";
export var sectionSpacingB = "blog-module--section-spacing-b--hsgbW";
export var sectionSpacingT = "blog-module--section-spacing-t--m5WlE";